import React, { useState } from 'react';

import SEO from '../seo';
import JsonLd from '../jsonld';
import CanonicalLink from '../../components/canonical-link';

/**
 * @component renderSEO
 *
 * @param {string} pageTitle
 * @param {string} metaDescription
 * @param {string} slug
 * @param {array} heroSectionImages
 * @param {object} pageContext
 *
 * @returns {JSX}
 */
const renderSEO = (pageTitle, metaDescription, slug, heroSectionImages, pageContext) => {
  const [seoSlug, setSeoSlug] = useState('');
  const heroImage = heroSectionImages?.length
    ? heroSectionImages[0]?.gatsbyImageData?.images?.fallback?.src
    : heroSectionImages?.gatsbyImageData?.images?.fallback?.src || null;
  const isRegionalContent = pageContext.spaceId !== process.env.CONTENTFUL_GLOBAL_SPACE_ID;
  const handleSeoSlugChange = value => {
    setSeoSlug(value);
  };
  return (
    <>
      <SEO title={pageTitle} description={metaDescription || ''} slug={seoSlug} image={heroImage} />
      <CanonicalLink
        isRegionalContent={isRegionalContent}
        contentType={'about-us'}
        contentSlug={slug}
        onSeoSlugChange={handleSeoSlugChange}
      />
      <JsonLd
        item={{
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          name: pageTitle,
          alternateName: slug,
          description: metaDescription || '',
          abstract: metaDescription || '',
          headline: pageTitle,
          inLanguage: 'en',
          url: `http://credera.com/about-us/${slug}`,
          isAccessibleForFree: true,
          image: heroImage
        }}
      />
    </>
  );
};

export default renderSEO;
